import { createGlobalStyle } from 'styled-components';

const GlobalStyleSheet = createGlobalStyle`
  * {
    -webkit-tap-highlight-color: transparent;
    -webkit-overflow-scrolling: touch;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0;
    padding: 0;
    font-family: 'TT Commons Pro';
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
    background-color: #FFFFFF;
    padding: 0;
    margin: 0;
    font-family: Segma, sans-serif;
    font-size: 12px;

    & #__next {
      min-height: 100%;
      display: flex;
      flex-direction: column;
    }


    header {
      z-index: 1000 !important;
    }

    ${({ isDesktop }) =>
      isDesktop &&
      `
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 100vh;
        background-color: white;
        min-width: 1068px !important;
        font-family: Segma, sans-serif;
      `}
  }
`;

export default GlobalStyleSheet;
